import _ from 'lodash';
import {
  ecommerceAddToCartEvent,
  ecommerceSelectItemEvent,
  ecommerceViewItemEvent,
  esputnikAddToCart,
  generateVisitorId,
  getCookie,
  getProductPriceTitle
} from '@/helpers';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import IconMinus from '@/components/icons/IconMinus.vue';
import IconPlus from '@/components/icons/IconPlus.vue';
import StarRating from 'vue-star-rating';
import { MEDIA } from '@/helpers/variables';
import { debounce } from 'lodash';

export default {
  name: 'ProductInfo',
  components: { IconPlus, IconMinus, StarRating },
  props: {
    productData: {
      type: Object,
      default: () => {}
    },
    seriesProducts: {
      type: Array,
      default: () => []
    }
  },
  emits: ['change-selected-price'],
  data() {
    return {
      MEDIA,
      selectedCount: 1,
      leftoverType: null,
      selectedProductPrice: null,
      isLoadingSyncProductPrice: false
    };
  },
  created() {
    this._checkValue();

    let { productPrices, title } = this.productData;

    ecommerceViewItemEvent({
      item_id: productPrices.data[0].id,
      item_name: title,
      item_brand: this.productData.brandSeries?.title || 'Renew',
      item_category: this.productData.brand?.title || '',
      item_variant: productPrices.data[0].title,
      price: productPrices.data[0].price
    });
  },
  computed: {
    ...mapGetters(['currentLanguage']),
    ...mapGetters({
      isUserWithCode: 'profile/isUserWithCode',
      user: 'profile/user',
      basket: 'basket/basket',
      productPriceByCount: 'products/productPriceByCount',
      showNotifyLoader: 'products/showNotifyLoader',
      changeFastBuyPopup: `popups/CHANGE_FAST_BUY_POPUP`,
      appSize: 'app/size'
    }),
    isHasDuplicate() {
      return this.productData.hasDuplicate;
    },
    isOutStock() {
      return this.leftoverType.displayType === 'out-stock';
    },
    isShowWithoutPrice() {
      return this.selectedProductPrice && this.selectedProductPrice.showWithoutPrice;
    },
    isCanBePurchased() {
      return !this.isOutStock && !this.isHasDuplicate && !this.isShowWithoutPrice;
    },
    isDiscontinued() {
      return this.productData.discontinued;
    },
    isHasAnalogue() {
      return this.productData.analogueProduct && this.productData.analogueProduct.data;
    },
    isComingSoon() {
      return this.productData.isComingSoon;
    },
    /*unauthorised or authorised without code*/
    isRegularUser() {
      return !this.isUserWithCode;
    },
    professionalLink() {
      let key = this.currentLanguage?.key ? this.currentLanguage.key + '/' : '';
      return `${process.env.VUE_APP_URL_PROFESSIONAL}${key}catalog?brands=renew`;
    }
  },
  methods: {
    ...mapActions({
      getProduct: 'products/GET_PRODUCT',
      showNotifyPopup: 'products/SHOW_POPUP_PRODUCT_WHEN_AVAILABLE'
    }),
    ...mapMutations({
      addToBasket: `basket/ADD_ITEM_TO_BASKET`,
      modalOpen: 'app/MODAL_OPEN'
    }),
    getProductPriceTitle,
    _checkValue() {
      const productPrices = this.productData.productPrices.data;

      const productPrice = _.find(productPrices, (item) => this.isSelectedPrice(item));

      this.onSelectProductPrice(productPrice || productPrices[0]);
    },
    _setSelectedCount(count, productPrice = null) {
      this.selectedCount = 0;
      const setQuantity = Math.min(
        Math.max(Number.parseFloat(count || '1'), 1),
        (productPrice || this.selectedProductPrice).quantity
      );

      this.selectedCount = Math.ceil(setQuantity);
      this._updateProductPrices(this.selectedCount);
    },

    _updateProductPrices: debounce(async function (count) {
      this.isLoadingSyncProductPrice = true;
      await this.getProduct({
        slug: this.$route.params.slug,
        value: this.selectedProductPrice.value,
        count: count
      });
      this.isLoadingSyncProductPrice = false;
    }, 300),

    /**
     * @param {ProductPrice} productPrice
     * @return {string}
     */
    getBasePriceForUser(productPrice) {
      if (this.isUserWithCode) {
        const clientProductPrice = _.find(this.clientPrices, (price) => price.value === productPrice.value);

        if (!clientProductPrice) {
          return '0';
        }

        return clientProductPrice.basePrice.toFixed(0);
      }
      return '0';
    },

    isSelectedPrice(productPrice) {
      return this.selectedProductPrice
        ? parseInt(this.selectedProductPrice.value) === parseInt(productPrice.value)
        : false;
    },
    onSelectProductPrice(productPrice) {
      if (!this.leftoverType) {
        this.leftoverType = productPrice.leftoverType.data;
      }

      this.selectedProductPrice = productPrice;

      if (!this.isSelectedPrice(productPrice)) {
        this.leftoverType = productPrice.leftoverType.data;
        this._setSelectedCount(this.selectedCount, productPrice);
      }

      this.$emit('change-selected-price', this.selectedProductPrice);

      ecommerceSelectItemEvent({
        item_id: this.selectedProductPrice.id,
        item_name: this.productData.title,
        item_brand: this.productData.brandSeries?.title || 'Renew',
        item_category: this.productData.brand?.title || '',
        item_variant: this.selectedProductPrice.title,
        price: this.selectedProductPrice.price
      });
    },
    onChangeCount(type, count) {
      if (type === 'decrement' && this.selectedCount > 1) {
        this._setSelectedCount(this.selectedCount - 1);
      } else if (type === 'increment') {
        this._setSelectedCount(this.selectedCount + 1);
      } else {
        this._setSelectedCount(count);
      }
    },
    onAddBasket() {
      this.addToBasket({
        select_count: this.selectedCount,
        product_price: this.selectedProductPrice,
        product: this.productData,
        unauthorizedProductPriceId: this.productData.unauthorizedProductPriceId
      });

      ecommerceAddToCartEvent({
        value: (this.selectedCount * this.selectedProductPrice.price).toFixed(2),
        item_id: this.selectedProductPrice.id,
        item_name: this.productData.title,
        item_brand: this.productData.brandSeries?.title || 'Renew',
        item_category: this.productData.brand?.title || '',
        item_variant: this.selectedProductPrice.title,
        price: this.selectedProductPrice.price,
        quantity: this.selectedCount,
        content_ids: this.productData.unauthorizedProductPriceId
      });

      //---ESputnik
      let esputnikPayload = {
        params: []
      };

      let visitorId = getCookie('visitorUUID');
      if (!visitorId) {
        visitorId = generateVisitorId();
      }

      esputnikPayload.params.push({
        name: 'externalCustomerId',
        value: visitorId
      });

      if (this.user) {
        esputnikPayload = { ...esputnikPayload, keyValue: this.user.email };
        esputnikPayload.params.push({
          name: 'EmailAddress',
          value: this.user.email
        });
      }

      let { uaTitle, image, brand } = this.productData;

      esputnikPayload.params.push(
        {
          name: 'productName',
          value: uaTitle
        },
        {
          name: 'categoryName',
          value: brand ? brand.title : ''
        },
        {
          name: 'Price',
          value: this.selectedProductPrice.price
        },
        {
          name: 'URL',
          value: window.location.href
        },
        {
          name: 'imageURL',
          value: image
        }
      );

      if (this.seriesProducts.length) {
        let seriesProducts = this.seriesProducts.slice(0, 2);
        seriesProducts.forEach((item, index) => {
          let { uaTitle, productPrices, image, slug, brand } = item;

          console.log('router', this.$route);

          let langPath = this.$route.params.lang ? `${this.$route.params.lang}/` : '';
          let productPath = `katalog/${brand.slug}/${slug}/`;
          let similarUrl = `${window.location.origin}/${langPath}${productPath}`;

          esputnikPayload.params.push(
            {
              name: `similar${index + 1}name`,
              value: uaTitle
            },
            {
              name: `similar${index + 1}price`,
              value: productPrices && productPrices.data.length ? productPrices.data[0].price : ''
            },
            {
              name: `similar${index + 1}URL`,
              value: similarUrl
            },
            {
              name: `similar${index + 1}image`,
              value: image
            }
          );
        });
      }

      esputnikAddToCart(esputnikPayload);

      this.modalOpen('basketModal');
      this.$toasted.success(this.$t('toast.successAddBasket'));
    },

    onShowNotify() {
      const payload = {
        product_id: this.productData.id,
        product_price_id: this.selectedProductPrice.id
      };

      this.showNotifyPopup(payload);
    },

    onOpenFastBuy() {
      this.changeFastBuyPopup({
        show: true,
        product: {
          select_count: 1,
          select_type: this.selectedProductPrice,
          ...this.productData
        }
      });
    }
  }
};
